import {
  GetKitCombinationCount,
  GetKitCombinationsPageParams,
  KitDetails,
} from '../../../services/modules/kit/kitDetails/kitDetails.types';
import { onlineKitDetailsRepository } from '../../../services/modules/kit/kitDetails/onlineKitDetails.repository';
import { offlineKitsRepository } from '../repositories/offlineKits.repository';
import OfflineKitToKitDetailsTransformers from '../transformers/OfflineDatabaseKit.toKitDetails.transformers';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';
import { KitDetailsQueriesUtils } from './utils/kitDetailsQueries.utils';

const onlineKitDetailsRepositoryOfflineAdapters = (): ReturnType<
  typeof onlineKitDetailsRepository
> => {
  return {
    getKitDetails: async (kitId: string) => {
      const offlineKit = await offlineKitsRepository.getByIdOrFail(kitId);

      const formatted = OfflineKitToKitDetailsTransformers.toKitDetails(offlineKit);

      return createApiSauceResponse<KitDetails>({ ok: true, data: formatted });
    },
    getKitCombinationsCount: async (params: GetKitCombinationsPageParams) => {
      const kit = await offlineKitsRepository.getByIdOrFail(params.kitId);
      const combinationsCount = await new KitDetailsQueriesUtils().getCombinationsCount(
        kit,
        params,
      );

      return createApiSauceResponse<GetKitCombinationCount[]>({
        ok: true,
        data: combinationsCount,
      });
    },
    getKitCombinationsPage: async (params: GetKitCombinationsPageParams) => {
      const kit = await offlineKitsRepository.getByIdOrFail(params.kitId);
      const combinations = await new KitDetailsQueriesUtils().getCombinations(kit, params);

      return createApiSauceResponse({ ok: true, data: combinations });
    },
  };
};
export default onlineKitDetailsRepositoryOfflineAdapters;
